import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Tutor } from '../models/tutor';

@Injectable({
  providedIn: 'root'
})
export class TutorService {

  constructor(
    private _http: HttpClient
  ) {}

  public getTutors(): Observable<any>{
    return this._http.get(environment.apiEndpoint + '/api/tutors').pipe(
      map(
        res => {
          return res;
        }
      )
    );
  }

  public getTutor(id:number):Observable<any>{
    return this._http.get(environment.apiEndpoint+'/api/tutor/'+id).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }
}
